
import sanitizeHtml from 'sanitize-html';
import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { PageDto, PageType, EventDto, PageScope } from 'fourwaves-shared';
import { NuxtError } from '@nuxt/types';
import Header from '~/components/layout/Header.vue';
import LegacyHeader from '~/components/layout/LegacyHeader.vue';
import ContentBlockList from '~/components/page-builder/ContentBlockList.vue';
import EventDetails from '~/components/page-builder/EventDetails.vue';

const EventsModule = namespace('events');

@Component({
  scrollToTop: true,
  components: {
    Header,
    LegacyHeader,
    ContentBlockList,
    EventDetails,
  },
  validate({ params, store }) {
    // home page is always accessible
    if (params.id == null) return true;

    const page = store.state.events.pages.find(({ id }: PageDto) => id === params.id);
    if (page && page.scope === PageScope.Participants) {
      if (!store.$auth.loggedIn) {
        const error: NuxtError = new Error();
        error.statusCode = 401;
        throw error;
      } else if (!store.getters['events/isParticipant'] && !store.getters['events/isOrganizer']) {
        const error: NuxtError = new Error();
        error.statusCode = 403;
        throw error;
      }
    }
    return !!page;
  },
})
export default class Page extends Vue {
  @EventsModule.Getter currentEvent!: EventDto;
  @EventsModule.State pages!: PageDto[];

  readonly PageType = PageType;

  public page: PageDto | null = null;

  get contentBlocks() {
    return this.page?.contentPage?.contentBlocks ?? [];
  }

  public head() {
    return { title: this.page && this.page.type !== PageType.Home ? this.transl8(this.page.name) : '' };
  }

  created() {
    const page = this.$route.params.id
      ? this.pages.find(page => page.id === this.$route.params.id)
      : this.pages.find(page => page.type === PageType.Home);
    if (page) {
      this.page = page;
    }

    // msg (already_registered e.g.)
    const toastMessage = this.$route.query.tmsg;
    if (toastMessage && typeof toastMessage === 'string') {
      const query = Object.assign({}, this.$route.query);
      delete query.tmsg;
      this.$router.replace({ query });

      // show "please log in" message only when not authenticated
      if (!this.$auth.loggedIn && process.client) {
        const sanitizedMessage = sanitizeHtml(this.$t(toastMessage) as string);
        this.$toast.success(sanitizedMessage);
      }
    }
  }
}
